const NamibiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111964)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.85816 34.1414C6.69715 34.9804 7.5923 35.7286 8.53129 36.3873L36.3882 8.53031C35.7296 7.59133 34.9814 6.69617 34.1423 5.85719C33.3033 5.0182 32.4082 4.27008 31.4692 3.61133L3.6123 31.4684C4.27098 32.4072 5.01918 33.3024 5.85816 34.1414Z"
        fill="#A2001D"
      />
      <path
        d="M5.85811 5.8589C-0.451576 12.1686 -1.66283 21.6445 2.22178 29.1712L29.1704 2.22273C21.6437 -1.66188 12.1676 -0.450478 5.85811 5.8589Z"
        fill="#0052B4"
      />
      <path
        d="M34.1423 34.1414C40.4519 27.8319 41.6631 18.3559 37.7787 10.8291L10.8301 37.7777C18.3567 41.6623 27.8327 40.4511 34.1423 34.1414Z"
        fill="#496E2D"
      />
      <path
        d="M16.5215 11.3043L14.2804 12.3585L15.4738 14.5289L13.0403 14.0635L12.7319 16.5217L11.0369 14.7136L9.34178 16.5217L9.0335 14.0635L6.5999 14.5289L7.79326 12.3584L5.55225 11.3043L7.79334 10.2501L6.5999 8.0798L9.03342 8.54527L9.34186 6.08691L11.0369 7.89504L12.7319 6.08691L13.0403 8.54527L15.4738 8.0798L14.2805 10.2502L16.5215 11.3043Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111964">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NamibiaSvg;
